import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
// @ts-ignore - JSX module
import { getGuestVideoStreamUrl } from '@/components/ui/PhotoGallery';

/**
 * Lecteur vidéo pour un invité : la page /videos/{id} exige un compte, et la lightbox
 * n'affiche que la première image. La vidéo est lue via la route de l'invitation.
 */
export default function GuestVideoDialog({
    video,
    invitationUuid,
    onClose,
}: {
    video: { uniq_id: string; thumbnailUrl?: string; previewUrl?: string } | null;
    invitationUuid: string;
    onClose: () => void;
}) {
    const { t } = useTranslation('public');

    return (
        <Dialog open={!!video} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <DialogContent className="sm:max-w-[720px] p-0 gap-0 overflow-hidden bg-background">
                <DialogHeader className="px-6 pt-6 pb-4">
                    <DialogTitle className="text-lg font-semibold text-foreground">
                        {t('reportForm.timestampedVideo')}
                    </DialogTitle>
                </DialogHeader>
                {video && (
                    <video
                        // key : force un nouvel élément à chaque vidéo pour repartir du début
                        key={video.uniq_id}
                        src={getGuestVideoStreamUrl(invitationUuid, video.uniq_id)}
                        controls
                        autoPlay
                        playsInline
                        preload="metadata"
                        poster={video.thumbnailUrl || video.previewUrl || undefined}
                        className="w-full max-h-[70vh] object-contain bg-black"
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}
